import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { List } from 'immutable';
import dig from 'object-dig';
import ReportStore from '../stores/ReportStore';
import MainPage from '../components/MainPage.react';
import TableauViz from '../components/TableauViz.react';
import TableauVizPicker from '../components/TableauVizPicker.react';
import TableauActions from '../actions/TableauActions';


class Tableau extends Component {
  constructor(props) {
    super(props);
    this.state = this.getReportState();
    this.onWorkbookChange = this.onWorkbookChange.bind(this);
    this.onViewChange = this.onViewChange.bind(this);
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.reportSubscription = ReportStore.addListener(this._onChange);
    TableauActions.loadWorkbooksForCurrentOrg();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.params.reportpart && !nextProps.params.viewpart && this.state.views) {
      const view = this.state.views.get(nextProps.params.reportpart).first();
      if (view) {
        this.props.router.replace(`${this.mountPoint()}/${view.viewPath}`);
      }
    }
  }

  componentWillUnmount() {
    this.reportSubscription.remove();
  }

  onWorkbookChange(newWorkbook) {
    const currentView = this.state.views.get(newWorkbook, new List()).first();
    this.props.router.push(`${this.mountPoint()}/${currentView.viewPath}`);
  }

  onViewChange(newView) {
    this.props.router.push(`${this.mountPoint()}/${newView}`);
  }

  getReportState() {
    const newState = {
      reports: ReportStore.getWorkbooksAlphabetical(),
      views: ReportStore.getViews(),
    };

    if (this.props.reportsFilter) {
      newState.reports = this.props.reportsFilter(newState.reports);
    }

    return newState;
  }

  determineTableauOptionsFromProps() {
    if (dig(this.props, 'location', 'query', 'run_name')) {
      return { run_name: this.props.location.query.run_name };
    }
    return {};
  }

  mountPoint() {
    // This makes the hacky but currently safe assumption that this
    // component will always be mounted at /<mount-point>/<report/view>
    return `/${this.props.routes[this.props.routes.length - 2].path}`;
  }

  _onChange() {
    const reportState = this.getReportState();
    this.setState(reportState);
    if (this.props.params.reportpart && !this.props.params.viewpart) {
      const firstView = reportState.views.get(this.props.params.reportpart).first();
      this.props.router.replace(`${this.mountPoint()}/${firstView.viewPath}`);
    } else if (!this.props.params.reportpart && !reportState.reports.isEmpty()) {
      const report = reportState.reports.first();
      const firstView = report.views.first();
      this.props.router.replace(`${this.mountPoint()}/${firstView.viewPath}`);
    }
  }

  render() {
    const { reportpart, viewpart } = this.props.params;
    const { reports, views } = this.state;
    const availableViews = views.get(reportpart, new List());

    const fullViewPath = viewpart ? `${reportpart}/${viewpart}` : undefined;

    const currentView = viewpart ?
      availableViews.find((v) => v.viewPath === fullViewPath) : undefined;

    const tableauOptions = this.determineTableauOptionsFromProps();

    return (
      <MainPage className='tableauPage'>
        <TableauVizPicker
          workbooks={reports}
          views={availableViews}
          selectedWorkbook={reportpart}
          selectedViewPath={fullViewPath}
          onWorkbookChange={this.onWorkbookChange}
          onViewChange={this.onViewChange}
          workbookLabel={this.props.workbookLabel}
        />

        <div className='tableauContainer'>
          {currentView && <TableauViz view={currentView} tableauOptions={tableauOptions} />}
        </div>
      </MainPage>
    );
  }
}

Tableau.propTypes = {
  params: PropTypes.object,
  router: PropTypes.object,
  routes: PropTypes.array,
  location: PropTypes.shape({
    query: PropTypes.shape({
      run_name: PropTypes.string,
    }),
  }),
  workbookLabel: PropTypes.string.isRequired,
  reportsFilter: PropTypes.func,
};

Tableau.defaultProps = {
  workbookLabel: 'Workbook',
};

export default withRouter(Tableau);
